module.exports = __webpack_public_path__ + "x5.no2.1d635d8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/x5.no2.jpg
// module id = mMt7
// module chunks = 0